import { getOrdersReturn, deleteOrderReturn } from "@/api/Purchases/orders_return";
import { useMutation, useQuery, useQueryClient } from "react-query";
import _ from "lodash";

const key = "purchase_orders_return";

export function useOrderReturnPaginate(params) {
	return useQuery([key, { ...params }], () => getOrdersReturn(params));
}

export function useOrderReturnDelete(base, params) {
	const queryClient = useQueryClient();

	return useMutation(deleteOrderReturn, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_return");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}
